import { Language } from '~/Features/Localization/Language.csharp';
import { assertNever } from '~/Partials/Utils/typeUtils';

export type LocaleType = 'en-GB' | 'nb';
export type LanguageCode = 'en' | 'no';

export const englishLocale = 'en-GB';
export const norwegianLocale = 'nb';
export const norwegianDocumentLanguage = 'no';
export const englishDocumentLanguage = 'en';

export type DocumentLanguage = typeof norwegianDocumentLanguage | typeof englishDocumentLanguage;

export const mapToLanguageCode = (language: Language | DocumentLanguage | LocaleType): LanguageCode => {
    switch (language) {
        case Language.English:
        case englishDocumentLanguage:
        case englishLocale:
            return 'en';
        case Language.Norwegian:
        case norwegianDocumentLanguage:
        case norwegianLocale:
            return 'no';
        default:
            throw new Error(`Language is not supported: ${language}`);
    }
};

export const mapToLocale = (code: LanguageCode): LocaleType => {
    switch (code) {
        case 'en':
            return englishLocale;
        case 'no':
            return norwegianLocale;
        default:
            assertNever(code);
    }
};
